import { render, staticRenderFns } from "./ContactInfoForm.vue?vue&type=template&id=2605cf9f&"
import script from "./ContactInfoForm.vue?vue&type=script&lang=js&"
export * from "./ContactInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports